import React from 'react';
import {FieldArray, useFormikContext} from 'formik';
import {Button, Icon, Input} from '../UI';
import { TICAFormValues } from '../../common/interfaces';

export const OfficesList = () => {
  const { values } = useFormikContext<TICAFormValues>();

  return (
    <FieldArray name="offices">
      {({ push, remove }) => (
        <div className="space-y-4">
          {values.offices.map((_, index) => (
            <div key={index} className="flex items-end">
              <span className="w-10 text-slate-500 font-semibold">{index + 1}.</span>

              <div className="w-full mr-2">
                <Input name={`offices.${index}.address`} label="Address" />
              </div>

              {values.offices.length > 1 && (
                <Button onClick={() => remove(index)}>
                  <Icon prefix='fal' icon='trash-alt' />
                </Button>
              )}
            </div>
          ))}

          <div className='flex justify-end'>
            <Button
              type='button'
              size='xs'
              onClick={() => push({ address: '' })}>
              + Add Office
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
};